module.exports = __webpack_public_path__ + "static/media/result-3-en.c09e2db9.png";